var map = {
	"./square/ac.svg": 1754,
	"./square/ad.svg": 1755,
	"./square/ae.svg": 1756,
	"./square/af.svg": 1757,
	"./square/ag.svg": 1758,
	"./square/ai.svg": 1759,
	"./square/al.svg": 1760,
	"./square/am.svg": 1761,
	"./square/ao.svg": 1762,
	"./square/aq.svg": 1763,
	"./square/ar.svg": 1764,
	"./square/as.svg": 1765,
	"./square/at.svg": 1766,
	"./square/au.svg": 1767,
	"./square/aw.svg": 1768,
	"./square/ax.svg": 1769,
	"./square/az.svg": 1770,
	"./square/ba.svg": 1771,
	"./square/bb.svg": 1772,
	"./square/bd.svg": 1773,
	"./square/be.svg": 1774,
	"./square/bf.svg": 1775,
	"./square/bg.svg": 1776,
	"./square/bh.svg": 1777,
	"./square/bi.svg": 1778,
	"./square/bj.svg": 1779,
	"./square/bl.svg": 1780,
	"./square/bm.svg": 1781,
	"./square/bn.svg": 1782,
	"./square/bo.svg": 1783,
	"./square/bq.svg": 1784,
	"./square/br.svg": 1785,
	"./square/bs.svg": 1786,
	"./square/bt.svg": 1787,
	"./square/bv.svg": 1788,
	"./square/bw.svg": 1789,
	"./square/by.svg": 1790,
	"./square/bz.svg": 1791,
	"./square/ca.svg": 1792,
	"./square/cc.svg": 1793,
	"./square/cd.svg": 1794,
	"./square/cefta.svg": 1795,
	"./square/cf.svg": 1796,
	"./square/cg.svg": 1797,
	"./square/ch.svg": 1798,
	"./square/ci.svg": 1799,
	"./square/ck.svg": 1800,
	"./square/cl.svg": 1801,
	"./square/cm.svg": 1802,
	"./square/cn.svg": 1803,
	"./square/co.svg": 1804,
	"./square/cp.svg": 1805,
	"./square/cr.svg": 1806,
	"./square/cu.svg": 1807,
	"./square/cv.svg": 1808,
	"./square/cw.svg": 1809,
	"./square/cx.svg": 1810,
	"./square/cy.svg": 1811,
	"./square/cz.svg": 1812,
	"./square/de.svg": 1813,
	"./square/dg.svg": 1814,
	"./square/dj.svg": 1815,
	"./square/dk.svg": 1816,
	"./square/dm.svg": 1817,
	"./square/do.svg": 1818,
	"./square/dz.svg": 1819,
	"./square/ea.svg": 1820,
	"./square/ec.svg": 1821,
	"./square/ee.svg": 1822,
	"./square/eg.svg": 1823,
	"./square/eh.svg": 1824,
	"./square/er.svg": 1825,
	"./square/es-ct.svg": 1826,
	"./square/es-ga.svg": 1827,
	"./square/es.svg": 1828,
	"./square/et.svg": 1829,
	"./square/eu.svg": 1830,
	"./square/fi.svg": 1831,
	"./square/fj.svg": 1832,
	"./square/fk.svg": 1833,
	"./square/fm.svg": 1834,
	"./square/fo.svg": 1835,
	"./square/fr.svg": 1836,
	"./square/ga.svg": 1837,
	"./square/gb-eng.svg": 1838,
	"./square/gb-nir.svg": 1839,
	"./square/gb-sct.svg": 1840,
	"./square/gb-wls.svg": 1841,
	"./square/gb.svg": 1842,
	"./square/gd.svg": 1843,
	"./square/ge.svg": 1844,
	"./square/gf.svg": 1845,
	"./square/gg.svg": 1846,
	"./square/gh.svg": 1847,
	"./square/gi.svg": 1848,
	"./square/gl.svg": 1849,
	"./square/gm.svg": 1850,
	"./square/gn.svg": 1851,
	"./square/gp.svg": 1852,
	"./square/gq.svg": 1853,
	"./square/gr.svg": 1854,
	"./square/gs.svg": 1855,
	"./square/gt.svg": 1856,
	"./square/gu.svg": 1857,
	"./square/gw.svg": 1858,
	"./square/gy.svg": 1859,
	"./square/hk.svg": 1860,
	"./square/hm.svg": 1861,
	"./square/hn.svg": 1862,
	"./square/hr.svg": 1863,
	"./square/ht.svg": 1864,
	"./square/hu.svg": 1865,
	"./square/ic.svg": 1866,
	"./square/id.svg": 1867,
	"./square/ie.svg": 1868,
	"./square/il.svg": 1869,
	"./square/im.svg": 1870,
	"./square/in.svg": 1871,
	"./square/io.svg": 1872,
	"./square/iq.svg": 1873,
	"./square/ir.svg": 1874,
	"./square/is.svg": 1875,
	"./square/it.svg": 1876,
	"./square/je.svg": 1877,
	"./square/jm.svg": 1878,
	"./square/jo.svg": 1879,
	"./square/jp.svg": 1880,
	"./square/ke.svg": 1881,
	"./square/kg.svg": 1882,
	"./square/kh.svg": 1883,
	"./square/ki.svg": 1884,
	"./square/km.svg": 1885,
	"./square/kn.svg": 1886,
	"./square/kp.svg": 1887,
	"./square/kr.svg": 1888,
	"./square/kw.svg": 1889,
	"./square/ky.svg": 1890,
	"./square/kz.svg": 1891,
	"./square/la.svg": 1892,
	"./square/lb.svg": 1893,
	"./square/lc.svg": 1894,
	"./square/li.svg": 1895,
	"./square/lk.svg": 1896,
	"./square/lr.svg": 1897,
	"./square/ls.svg": 1898,
	"./square/lt.svg": 1899,
	"./square/lu.svg": 1900,
	"./square/lv.svg": 1901,
	"./square/ly.svg": 1902,
	"./square/ma.svg": 1903,
	"./square/mc.svg": 1904,
	"./square/md.svg": 1905,
	"./square/me.svg": 1906,
	"./square/mf.svg": 1907,
	"./square/mg.svg": 1908,
	"./square/mh.svg": 1909,
	"./square/mk.svg": 1910,
	"./square/ml.svg": 1911,
	"./square/mm.svg": 1912,
	"./square/mn.svg": 1913,
	"./square/mo.svg": 1914,
	"./square/mp.svg": 1915,
	"./square/mq.svg": 1916,
	"./square/mr.svg": 1917,
	"./square/ms.svg": 1918,
	"./square/mt.svg": 1919,
	"./square/mu.svg": 1920,
	"./square/mv.svg": 1921,
	"./square/mw.svg": 1922,
	"./square/mx.svg": 1923,
	"./square/my.svg": 1924,
	"./square/mz.svg": 1925,
	"./square/na.svg": 1926,
	"./square/nc.svg": 1927,
	"./square/ne.svg": 1928,
	"./square/nf.svg": 1929,
	"./square/ng.svg": 1930,
	"./square/ni.svg": 1931,
	"./square/nl.svg": 1932,
	"./square/no.svg": 1933,
	"./square/np.svg": 1934,
	"./square/nr.svg": 1935,
	"./square/nu.svg": 1936,
	"./square/nz.svg": 1937,
	"./square/om.svg": 1938,
	"./square/pa.svg": 1939,
	"./square/pe.svg": 1940,
	"./square/pf.svg": 1941,
	"./square/pg.svg": 1942,
	"./square/ph.svg": 1943,
	"./square/pk.svg": 1944,
	"./square/pl.svg": 1945,
	"./square/pm.svg": 1946,
	"./square/pn.svg": 1947,
	"./square/pr.svg": 1948,
	"./square/ps.svg": 1949,
	"./square/pt.svg": 1950,
	"./square/pw.svg": 1951,
	"./square/py.svg": 1952,
	"./square/qa.svg": 1953,
	"./square/re.svg": 1954,
	"./square/ro.svg": 1955,
	"./square/rs.svg": 1956,
	"./square/ru.svg": 1957,
	"./square/rw.svg": 1958,
	"./square/sa.svg": 1959,
	"./square/sb.svg": 1960,
	"./square/sc.svg": 1961,
	"./square/sd.svg": 1962,
	"./square/se.svg": 1963,
	"./square/sg.svg": 1964,
	"./square/sh.svg": 1965,
	"./square/si.svg": 1966,
	"./square/sj.svg": 1967,
	"./square/sk.svg": 1968,
	"./square/sl.svg": 1969,
	"./square/sm.svg": 1970,
	"./square/sn.svg": 1971,
	"./square/so.svg": 1972,
	"./square/sr.svg": 1973,
	"./square/ss.svg": 1974,
	"./square/st.svg": 1975,
	"./square/sv.svg": 1976,
	"./square/sx.svg": 1977,
	"./square/sy.svg": 1978,
	"./square/sz.svg": 1979,
	"./square/ta.svg": 1980,
	"./square/tc.svg": 1981,
	"./square/td.svg": 1982,
	"./square/tf.svg": 1983,
	"./square/tg.svg": 1984,
	"./square/th.svg": 1985,
	"./square/tj.svg": 1986,
	"./square/tk.svg": 1987,
	"./square/tl.svg": 1988,
	"./square/tm.svg": 1989,
	"./square/tn.svg": 1990,
	"./square/to.svg": 1991,
	"./square/tr.svg": 1992,
	"./square/tt.svg": 1993,
	"./square/tv.svg": 1994,
	"./square/tw.svg": 1995,
	"./square/tz.svg": 1996,
	"./square/ua.svg": 1997,
	"./square/ug.svg": 1998,
	"./square/um.svg": 1999,
	"./square/un.svg": 2000,
	"./square/us.svg": 2001,
	"./square/uy.svg": 2002,
	"./square/uz.svg": 2003,
	"./square/va.svg": 2004,
	"./square/vc.svg": 2005,
	"./square/ve.svg": 2006,
	"./square/vg.svg": 2007,
	"./square/vi.svg": 2008,
	"./square/vn.svg": 2009,
	"./square/vu.svg": 2010,
	"./square/wf.svg": 2011,
	"./square/ws.svg": 2012,
	"./square/xk.svg": 2013,
	"./square/xx.svg": 2014,
	"./square/ye.svg": 2015,
	"./square/yt.svg": 2016,
	"./square/za.svg": 2017,
	"./square/zm.svg": 2018,
	"./square/zw.svg": 2019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1753;